import axios from 'axios';
let API_URL;
if (process.env.REACT_APP_DEV==='dev') {
  API_URL = process.env.REACT_APP_API_URL;
} else {
  API_URL = process.env.REACT_APP_API_BACKEND_URL;
}

/**
 * Tüm kullanıcıları getirir (sadece admin)
 * @returns {Promise<Array>} Kullanıcılar dizisi
 */
export const getUsers = async () => {
  try {
    const response = await axios.get(API_URL+'/users');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

/**
 * Admin/editor analyst list for report assignment
 */
export const getSelectableUsers = async () => {
  try {
    const response = await axios.get(`${API_URL}/users/selectable`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching selectable users:', error);
    throw error;
  }
};

/**
 * Belirli bir kullanıcıyı getirir
 * @param {string} id - Kullanıcı ID
 * @returns {Promise<Object>} Kullanıcı detayları
 */
export const getUserById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/users/${id}`);
    return response.data.data;
  } catch (error) {
    console.error(`Error fetching user ${id}:`, error);
    throw error;
  }
};

/**
 * Yeni kullanıcı oluşturur (sadece admin)
 * @param {Object} userData - Kullanıcı verileri
 * @returns {Promise<Object>} Oluşturulan kullanıcı
 */
export const createUser = async (userData) => {
  try {
    const response = await axios.post(API_URL+'/users', userData);
    return response.data.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

/**
 * Kullanıcı bilgilerini günceller (sadece admin)
 * @param {string} id - Kullanıcı ID
 * @param {Object} userData - Güncellenecek kullanıcı verileri
 * @returns {Promise<Object>} Güncellenmiş kullanıcı
 */
export const updateUser = async (id, userData) => {
  try {
    const response = await axios.put(`${API_URL}/users/${id}`, userData);
    return response.data.data;
  } catch (error) {
    console.error(`Error updating user ${id}:`, error);
    throw error;
  }
};

/**
 * Kullanıcıyı siler (sadece admin)
 * @param {string} id - Kullanıcı ID
 * @returns {Promise<boolean>} İşlem başarılı mı?
 */
export const deleteUser = async (id) => {
  try {
    await axios.delete(`${API_URL}/users/${id}`);
    return true;
  } catch (error) {
    console.error(`Error deleting user ${id}:`, error);
    throw error;
  }
};

/**
 * Kullanıcıya marka atar (sadece admin)
 * @param {string} userId - Kullanıcı ID
 * @param {Object} brandData - { brands: Array<string> } Marka ID'leri
 * @returns {Promise<Object>} Güncellenmiş kullanıcı
 */
export const assignBrands = async (userId, brandData) => {
  try {
    const response = await axios.post(`${API_URL}/users/${userId}/brands`, brandData);
    return response.data.data;
  } catch (error) {
    console.error(`Error assigning brands to user ${userId}:`, error);
    throw error;
  }
}; 